import React from 'react';
import styled from 'styled-components';
import { Tabs, Tab } from '@material-ui/core';
import { sanlamBlue } from 'Material-UI/colors';
import breakpoints from 'utils/breakpoints';

export const StyledTabsBlue = styled((props) => {
  return (
    <Tabs
      {...props}
      classes={{ indicator: 'indicator' }}
      TabIndicatorProps={{ children: <span /> }}
      variant="scrollable"
      scrollButtons="auto"
    />
  );
})`
  && {
    background-color: #fff;
  }
  && .indicator {
    bottom: 3px;
    display: flex;
    justify-content: center;
    background-color: transparent;
    height: 3px;
    > span {
      max-width: 170px;
      width: 100%;
      background-color: #2f89fc;
      border-radius: 1.5px;
    }
  }
`;
export const StyledTabs = styled((props) => {
  return (
    <Tabs
      {...props}
      classes={{ indicator: 'indicator' }}
      TabIndicatorProps={{ children: <span /> }}
      variant="scrollable"
      scrollButtons="auto"
    />
  );
})`
  && {
    background-color: #fff;
  }
  && .indicator {
    bottom: 3px;
    display: flex;
    justify-content: center;
    background-color: transparent;
    height: 3px;
    > span {
      max-width: 170px;
      width: 100%;
      background-color: ${sanlamBlue};
      border-radius: 1.5px;
    }
  }
`;

export const StyledTabBlue = styled(Tab)`
  && {
    width: auto;
    color: #2f89fc;
    font-size: 15px !important;
    font-weight: 400;
    line-height: 18px;
    text-transform: none;

    &:focus {
      color: #2f89fc !important;
      background-color: #fff !important;
      font-weight: 500;
    }
    &&.Mui-selected {
      color: #2f89fc;
      font-weight: 500;
    }
  }
`;
export const StyledTab = styled(Tab)`
  && {
    @media (max-width: ${breakpoints.xs}) {
      width: 161px;
    }
    width: 200px;
    color: #566684;
    font-size: 15px !important;
    font-weight: 400;
    line-height: 18px;
    text-transform: none;
    &:focus {
      color: ${sanlamBlue} !important;
      background-color: #fff !important;
      font-weight: 500;
    }
    &&.Mui-selected {
      color: ${sanlamBlue};
      font-weight: 500;
    }
  }
`;
